"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MenuPanelContainer;
var React = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
require("./index.scss");
var _formatVodData2 = require("../../utils/formatVodData");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function MenuPanelContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const bgImg = data.bgImg,
    color = data.color;
  const _formatVodData = (0, _formatVodData2.formatVodData)(bgImg),
    url = _formatVodData.url;
  const bgStyle = {};
  if (color) {
    bgStyle['background'] = color;
  }
  if (url) {
    bgStyle['background'] = `url(${url})`;
  }
  const renderChild = child => {
    return child ? /*#__PURE__*/React.cloneElement(child, {
      domains: domainInfos
    }) : child;
  };
  return /*#__PURE__*/React.createElement("section", {
    className: "banner-container",
    id: "banner-container",
    style: bgStyle
  }, React.Children.map(children, (child, index) => /*#__PURE__*/React.createElement("div", {
    style: commonStyle,
    key: index,
    id: `banner-container-child-${index}`
  }, renderChild(child))));
}